import { Recurrence } from '@tableau/self-service-schedules';
import { SelfServiceSchedulePaneProps, SelfServiceSchedulePaneType } from '@tableau/self-service-schedules/lib/src/components/SelfServiceSchedulePane';
import * as _ from 'underscore';
import { IRemoteRefreshScheduleTypeNameFilter } from '../filters/RemoteRefreshScheduleTypeNameFilter';
import { IActionContext } from '../helpers/ActionContext';
import { IDataSourceDetailInfo } from '../models/IDataSourceInfo';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { Module } from '../Module';
import { RemoteRefreshSchedules } from '../resources/RemoteRefreshSchedules';
import { RemoteRefreshTypes } from '../ServerApi/requests/GetRemoteRefreshSchedulesRequest';
import { IError } from '../../httpClient/serverApi/types/IError';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ISelfServiceScheduleDetails } from '../../schedule/types/ISchedule';
import { ChangeScheduleActionService, IChangeSelfServiceScheduleScope } from './ChangeScheduleAction';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ContentActionNotification } from '../../commonInfra/contentActions/ContentActionNotification';
import { ModalService } from './ModalService';

interface IScheduleInfo {
  refreshType: string;
}

export interface ICreateRemoteRefreshSelfServiceScheduleScope extends IChangeSelfServiceScheduleScope {
  availableTypeOptions: string[];
  scheduleInfo: IScheduleInfo;
}

export function setupDefaultScheduleDetailsForSSSWidget<T extends ICreateRemoteRefreshSelfServiceScheduleScope>(scope: T,
  availableTypes: string[], remoteAgentTimeZone: string) {
  scope.selfServiceSchedulePaneProps = getDefaultSelfServiceSchedulePanePropsForSSSWidget(remoteAgentTimeZone);
  scope.selfServiceSchedulePaneProps.recurrenceModelChangedCallback = (newRecurrence: Recurrence) => {
    scope.$apply(() => {
      scope.selfServiceSchedulePaneProps = {
        recurrenceModel: newRecurrence,
        timeZoneDetails: scope.selfServiceSchedulePaneProps.timeZoneDetails,
        recurrenceModelChangedCallback: scope.selfServiceSchedulePaneProps.recurrenceModelChangedCallback,
        type: scope.selfServiceSchedulePaneProps.type,
      };
    });
  };
  scope.availableTypeOptions = availableTypes;
  scope.scheduleInfo = {
    refreshType: RemoteRefreshTypes.Full,
  };
}

export function getDefaultSelfServiceSchedulePanePropsForSSSWidget(remoteAgentTimeZone: string): SelfServiceSchedulePaneProps {
    const scheduleDetails: ISelfServiceScheduleDetails = {
      startTime: 300,
      endTime: 0,
      recurrenceMinutes: 1440,
      recurrenceDaysOfWeek: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      recurrenceDayOfMonth: '0',
    };

    const selfServiceSchedulePaneProps = ChangeScheduleActionService.getSelfServiceSchedulePaneProps(
      scheduleDetails, remoteAgentTimeZone != null, remoteAgentTimeZone, 'Weekly',
    SelfServiceSchedulePaneType.BridgeExtractRefresh);
    return selfServiceSchedulePaneProps;
}